import { NavLink } from "react-router-dom";

import { cn } from "@/lib/utils";

// Brand-Logo links in der TopNav. `shrink-0` schuetzt vor Stauchen, wenn der
// Viewport eng wird (Phase 5.7) — der Container `flex items-center gap-6` in
// DesktopTopNav schrumpft sonst das Logo zuerst, weil Search-Bar und Account-
// Menu rechts Min-Breite halten.
export function HomeLogoLink() {
  return (
    <NavLink
      to="/"
      end
      className={({ isActive }) =>
        cn(
          "flex shrink-0 items-center rounded-sm px-1 py-1 transition-opacity",
          isActive ? "opacity-100" : "opacity-90 hover:opacity-100",
        )
      }
      aria-label="Bergler Energie OS - Home"
      data-testid="home-logo-link"
    >
      <img
        src="/logo.png"
        alt="Bergler Energie OS"
        className="h-7 w-auto shrink-0"
        width={28}
        height={28}
      />
    </NavLink>
  );
}
